export const addTrailingZeroes = (num) => parseFloat(num).toFixed(3);
